module.exports = __webpack_public_path__ + "media/images/work_articles_post_icon-de388166ad525811b499ad40ce2d8419.png";